import { render, staticRenderFns } from "./MotorNCDRateReview.vue?vue&type=template&id=46de024c&"
import script from "./MotorNCDRateReview.vue?vue&type=script&lang=js&"
export * from "./MotorNCDRateReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports